module.exports = __webpack_public_path__ + "heart.5b6e6a2b036d2cadb20b821fb7482542.png";